import { OrganizationConfig } from '@tenants/types/tenant';

export function createOrganizationConfig(): OrganizationConfig {
  return {
    phoneNumber() {
      return '1 833-303-0610';
    },
    email() {
      return 'info@exprealty.net';
    },
    address() {
      return '2219 Rimland Drive, Suite 301,\nBellingham, Washington, 98226';
    },
    twitterUrl: 'https://x.com/exprealty',
    facebookUrl: 'https://www.facebook.com/eXpRealty/',
    instagramUrl: 'https://www.instagram.com/exprealty',
    linkedinUrl: 'https://www.linkedin.com/company/exp-realty',
    youtubeUrl: 'https://www.youtube.com/@eXpRealty',
    joinSectionUrl: 'https://join.exprealty.com/',
  };
}
